import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL } from '../config';

const SEOMetaTags = () => {
  const [seo, setSeo] = useState(null);
  const location = useLocation();

  // Skip SEO injection pe paginile care au propriul Helmet
  const isAdminPage = location.pathname.startsWith('/admin');
  const isCityPage = location.pathname.startsWith('/certificat-constatator/');
  const isBlogPage = location.pathname.startsWith('/blog');
  const shouldSkipSEO = isAdminPage || isCityPage || isBlogPage;

  // Fetch SEO settings din API (doar pe homepage și pagini generale)
  useEffect(() => {
    if (shouldSkipSEO) return; // NU fetch SEO pe admin/city pages

    const fetchSEO = async () => {
      try {
        const response = await fetch(`${API_URL}/api/orders/seo`);
        const data = await response.json();
        setSeo(data);
      } catch (error) {
        console.error('Error fetching SEO settings:', error);
      }
    };

    fetchSEO();
  }, [shouldSkipSEO]);

  // Injectare meta tags când SEO data e disponibilă
  useEffect(() => {
    if (!seo || shouldSkipSEO) return; // Skip pe admin/city pages
    if (!seo.enabled) return; // Skip dacă SEO e dezactivat din Admin

    // Title, description si canonical vin din Helmet in fiecare pagina (pre-randate de react-snap).
    // NU le mai suprascriem aici - altfel termeni/politica/404 primeau title + canonical de homepage.

    // 1. Google Search Console verification
    if (seo.googleSiteVerification) {
      updateOrCreateMetaTag('name', 'google-site-verification', seo.googleSiteVerification);
    }

    // 2. AI Description (custom meta tag pentru AI crawlers)
    if (seo.ai?.indexingEnabled && seo.ai?.description) {
      updateOrCreateMetaTag('name', 'ai-description', seo.ai.description);
    } else {
      // Remove AI description meta tag dacă indexing e disabled
      removeMetaTag('name', 'ai-description');
    }

  }, [seo, shouldSkipSEO]);

  // Helper: Update sau creează meta tag
  const updateOrCreateMetaTag = (attributeName, attributeValue, content) => {
    if (!content) return; // Skip dacă content e gol

    let element = document.querySelector(`meta[${attributeName}="${attributeValue}"]`);

    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attributeName, attributeValue);
      document.head.appendChild(element);
    }

    element.setAttribute('content', content);
  };

  // Helper: Remove meta tag
  const removeMetaTag = (attributeName, attributeValue) => {
    const element = document.querySelector(`meta[${attributeName}="${attributeValue}"]`);
    if (element) {
      element.remove();
    }
  };

  // Componenta nu renderează nimic (doar side effects)
  return null;
};

export default SEOMetaTags;
